import { AddCircleOutline } from "@mui/icons-material";
import { Box, Card, CardActionArea, Typography } from "@mui/material";
import { CardList } from "../card-list.js";
import { darken } from "color2k";
import { getMinMaxPlayers } from "../utils.js";
import { ModalContent } from "./modal-content.js";
import { ModalPlayers } from "./modal-players.js";
import { ProductContext } from "../provider.js";
import { useTranslation } from "next-i18next";
import { WB_Age, WB_Contents, WB_DigitalContents, WB_Duration, WB_EAN, WB_Players } from "./icons.js";
import NiceModal from "@ebay/nice-modal-react";
import React from "react";
export const CardsLayout = () => {
    const { t } = useTranslation("c-product");
    const product = React.useContext(ProductContext);
    const { duration, ean } = product;
    const { minPlayers, maxPlayers } = getMinMaxPlayers(product);
    const backgroundColor = "#dff0f9";
    const color = darken(backgroundColor, 3.75);
    const showPlayersModal = () => NiceModal.show(ModalPlayers, { product });
    const showContentModal = () => NiceModal.show(ModalContent, { product });
    return (React.createElement(Box, { component: "section", id: "product-meta-cards", sx: {
            backgroundColor: "#dff0f9",
            boxShadow: "sectionBottom",
            pt: 8,
            pb: 8,
            position: "relative",
            zIndex: 25,
        } },
        React.createElement(CardList, { backgroundColor: backgroundColor, containerStyles: { pt: 4, pb: 3, color }, itemStyles: { backgroundColor: "white", color } },
            React.createElement(Card, { component: "li" },
                React.createElement(CardActionArea, { className: "container", sx: { borderRadius: "16px" }, onClick: showPlayersModal },
                    React.createElement(IconContainer, null,
                        React.createElement(WB_Players, null)),
                    React.createElement(BlobTitle, null, t("players", "Spieler")),
                    React.createElement(Typography, { color: "inherit", variant: "body1" }, t("players-copy-1", "{{minPlayers}} – {{maxPlayers}} Personen", {
                        minPlayers,
                        maxPlayers,
                    })),
                    React.createElement(MoreButton, null))),
            React.createElement(Card, { component: "li" },
                React.createElement(CardActionArea, { className: "container", sx: { borderRadius: "16px" }, disableRipple: true, disableTouchRipple: true },
                    React.createElement(IconContainer, null,
                        React.createElement(WB_Duration, null)),
                    React.createElement(BlobTitle, null, t("duration", "Dauer")),
                    React.createElement(Typography, { color: "inherit", variant: "body1" }, t("duration-copy-1", "{{min}} – {{max}} Stunden", {
                        min: duration.min,
                        max: duration.max,
                    })))),
            React.createElement(Card, { component: "li" },
                React.createElement(CardActionArea, { className: "container", sx: { borderRadius: "16px" }, disableRipple: true, disableTouchRipple: true },
                    React.createElement(IconContainer, null,
                        React.createElement(WB_Age, null)),
                    React.createElement(BlobTitle, null, t("age", "Alter")),
                    React.createElement(Typography, { color: "inherit", variant: "body1" }, t("age-recommendation", "Geeignet ab 16 Jahren")))),
            React.createElement(Card, { component: "li" },
                React.createElement(CardActionArea, { className: "container", sx: { borderRadius: "16px" }, onClick: showContentModal },
                    React.createElement(IconContainer, null, product.edition === "online" ? React.createElement(WB_DigitalContents, null) : React.createElement(WB_Contents, null)),
                    React.createElement(BlobTitle, null, t("contents", "Spielinhalt")),
                    React.createElement(Typography, { color: "inherit", variant: "body1" }, t("contents-subheadline", "Alles enthalten")),
                    React.createElement(MoreButton, null))),
            product.edition === "print" && (React.createElement(Card, { component: "li" },
                React.createElement(CardActionArea, { className: "container", sx: { borderRadius: "16px" }, disableRipple: true, disableTouchRipple: true },
                    React.createElement(IconContainer, null,
                        React.createElement(WB_EAN, null)),
                    React.createElement(BlobTitle, null, t("ean", "EAN")),
                    React.createElement(Typography, { color: "inherit", variant: "body1" }, ean)))))));
};
const IconContainer = ({ children }) => (React.createElement(Box, { sx: {
        color: "inherit",
        px: 1.5,
        transform: "scale3d(1.2,1.2,1.2)",
        transformStyle: "flat",
        width: "100%",
        mb: -0.5,
    } }, children));
const BlobTitle = ({ children }) => (React.createElement(Typography, { color: "inherit", component: "h3", variant: "h2", sx: { pt: 0, pb: 1 } }, children));
const MoreButton = () => (React.createElement(Box, { sx: { display: "flex", justifyContent: "center", pt: 1.5, pb: 0 } },
    React.createElement(AddCircleOutline, { sx: { color: "inherit" } })));
//# sourceMappingURL=cards-layout.js.map